var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ui-usable-dropdown',{attrs:{"nameFields":['Name'],"keyField":"Trigger","items":[_vm.noTrigger, ..._vm.triggers],"required":_vm.required},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }